import React from 'react';
import { colors } from '@styles/core-styles/theme';

export const SearchIcon: React.FC<{
	color?: string;
	width?: string;
	height?: string;
}> = ({ color = colors.orange, width = '100%', height = '100%' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 54 55"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.0676 37.3028C30.2404 37.3028 36.8657 30.6144 36.8657 22.3638C36.8657 14.1132 30.2404 7.4248 22.0676 7.4248C13.8949 7.4248 7.26953 14.1132 7.26953 22.3638C7.26953 30.6144 13.8949 37.3028 22.0676 37.3028Z"
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M31.2227 34.2051L33.8342 31.5629L46.3662 44.2419C46.6006 44.4791 46.7323 44.8007 46.7323 45.1361C46.7323 45.4715 46.6006 45.7931 46.3662 46.0302L45.5222 46.8842C45.2878 47.1213 44.9699 47.2545 44.6384 47.2545C44.3069 47.2545 43.989 47.1213 43.7546 46.8842L31.2227 34.2051Z"
				fill={color}
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
		</svg>
	);
};
